// =========================================================================
// HelpyDoc Metabolic · Los avisos del análisis, en castellano
// =========================================================================
// El array `warnings` del resultado mezcla dos cosas: frases que escribe el
// modelo («porción estimada sin referencia de escala») y CÓDIGOS estables que
// emiten el prompt y el orquestador (`NON_FOOD_IMAGE`,
// `PROMPT_INJECTION_ATTEMPT`, `PORCION_FUERA_DE_ESCALA_GEOMETRICA`).
//
// La pantalla los pintaba todos tal cual, así que un paciente podía leer
// `PROMPT_INJECTION_ATTEMPT` en mayúsculas debajo de su comida. Los códigos
// existen para que el sistema pueda razonar sobre ellos, no para enseñarlos.
//
// Aquí se traduce lo conocido y se deja pasar lo demás: un código nuevo se verá
// feo, pero se verá — que es mejor que desaparecer sin dejar rastro.
// =========================================================================

const TEXTOS: Record<string, string> = {
  NON_FOOD_IMAGE:
    'No se ha reconocido comida en la foto. Revisa el encuadre o introduce los datos a mano.',
  PROMPT_INJECTION_ATTEMPT:
    'La imagen contenía texto que se ha ignorado; solo se ha analizado la comida.',
  // Lo emite el orquestador cuando la porción del modelo se sale por completo
  // del rango que da la geometría del plato (ADR-016 §D2). No corrige la cifra:
  // avisa de que conviene mirarla.
  PORCION_FUERA_DE_ESCALA_GEOMETRICA:
    'La cantidad estimada no encaja con el tamaño del plato de la foto. Revísala antes de guardarla.',
};

/** Un aviso ya legible. Los códigos conocidos se traducen; el resto pasa igual. */
export function textoDeAviso(aviso: string): string {
  return TEXTOS[aviso] ?? aviso;
}

/** ¿Es uno de los códigos que el sistema sabe traducir? Útil para pruebas. */
export function esCodigoConocido(aviso: string): boolean {
  return aviso in TEXTOS;
}
